module.exports = __webpack_public_path__ + "static/media/icon.8d17998d.png";